import React from "react";
import { SITE } from "../config/siteConfig";
import { Logo } from "./Logo";

export function Footer() {
  const c = SITE.company;
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="wrap">
        <div className="footer-top">
          <Logo />
          <div className="footer-contact">
            <a href={SITE.phones.main.href} className="footer-phone">
              <span>{SITE.phones.main.display}</span>
            </a>
            <p>Conseillers disponibles {SITE.hours}.</p>
            <p>
              <a href={"mailto:" + c.email}>{c.email}</a>
            </p>
          </div>
        </div>
        <nav className="footer-links" aria-label="Liens utiles">
          <a href="/a-propos">À propos</a>
          <a href="/contact">Contact</a>
          <a href="/faq">FAQ</a>
          <a href="/avertissement">Avertissement</a>
          <a href="/cgu">CGU et mentions légales</a>
          <a href="/confidentialite">Politique de confidentialité</a>
          <a href="/cookies">Cookies</a>
        </nav>
        <p className="footer-legal">
          {SITE.siteLabel} est un service de comparaison édité par {c.name}, CIF {c.cif}, {c.address}.
        </p>
        <p className="footer-disclaimer">
          Les informations fournies sur ce site sont données à titre indicatif. {SITE.brandName} n'est ni un
          fournisseur{SITE.key === "energie" ? " d'énergie ni un gestionnaire de réseau" : " d'accès à internet ni un opérateur mobile"}
          , et n'est affilié à aucune des marques citées, qui restent la propriété de leurs titulaires respectifs.
        </p>
        <p className="footer-copy">© {year} {c.name}</p>
      </div>
    </footer>
  );
}
